export { default } from './ModelCard';
